//#region src/index.mts
const FeatureFlags = {
	SALE_TRANSFER_NOTICE_STEP_ONE_V2: "SaleTransferNoticeStepOneV2",
	ADD_RENTAL_MANAGEMENT_CONTRACT: "AddRentalManagementContract",
	ADD_REFERENCE_MANDATE_ON_CONTRACT_OR_WORKORDER: "AddReferenceMandateOnContractOrWorkorder",
	AGO: "AGO",
	MISSION_CURRENT_EXPENSE_RECOVERY_EDIT_BUDGET: "MissionCurrentExpenseRecoveryEditBudget",
	BUILDING_CO_OWNERSHIP_REGISTER: "BuildingCoOwnershipRegister",
	BUILDING_UPDATE_SCOPE: "BuildingUpdateScope",
	END_GENERAL_ASSEMBLY_WORKFLOW: "EndGeneralAssemblyWorkflow",
	GENERAL_ASSEMBLY_AUTOMATIC_BILLING: "GeneralAssemblyAutomaticBilling",
	DATEDSTATE_ARTICLE20: "DatedStateArticle20",
	DEFICIENCY_MINUTES: "DeficiencyMinutes",
	RESET_GENERAL_ASSEMBLY: "ResetGeneralAssembly",
	EDIT_ACCOUNTING_LINE_SUPPORT: "EditAccountingLineSupport",
	CANCEL_APPROVED_DISTRIBUTION_SUPPORT: "CancelApprovedDistributionSupport",
	EDIT_LETTERING_COPRO: "EditLetteringCopro",
	EXTERN_TRUSTEE_ACCOUNTING_PERIODS: "ExternTrusteeAccountingPeriods",
	EXTERNAL_GROWTH_AG: "ExternalGrowthAG",
	EXTERNAL_GROWTH_RESOLUTION_FONCIA_TRUSTEE_DESIGNATION: "ExternalGrowthResolutionFonciaTrusteeDesignation",
	GET_FUNDS_CALLS_PDF_END_DATE_FROM_REPLACEMENT_TIMETABLE: "GetFundsCallsPdfEndDateFromReplacementTimetable",
	FUNDS_CALLS_SHOW_STEP_FUNCTIONS: "FundsCallsShowStepFunctions",
	FUNDS_CALLS_BREAKING_POINTS: "FundsCallsBreakingPoints",
	FUNDSCALLSCANCELLATION: "FundsCallsCancellation",
	FUNDSCALLS_CANCELLATION_CASH_ADVANCE: "FundsCallsCancellationCashAdvance",
	FUNDSCALLS_CANCELLATION_CURRENT_EXPENSES: "FundsCallsCancellationCurrentExpenses",
	FUNDSCALLS_CANCELLATION_WORK_FUND_RESERVE: "FundsCallsCancellationWorkFundReserve",
	RUN_FUNDS_CALLS: "RunFundsCalls",
	LESSOR_TAX_DECLARATION: "LessorTaxDeclaration",
	LESSOR_TAX_DECLARATION_REFRESH: "LessorTaxDeclarationRefresh",
	LESSOR_PROPERTY_TAX_RECOVERABLE: "LessorPropertyTaxRecoverable",
	ADDITIONAL_TENANT_SETTLEMENT: "AdditionalTenantSettlement",
	METER_READING: "MeterReading",
	FLUIDS_INDEXES: "FluidsIndexes",
	MISSION_RCP: "MissionRCP",
	NEW_MISSION_RCP: "NewMissionRCP",
	MISSION_RCP_UNITS_SPLIT: "MissionRcpUnitsSplit",
	HOME_PAGE_UNITS_WIDGET: "HomePageUnitsWidgetUnits",
	MISSION_TRUSTEE_CONTRACT_GENERAL_ASSEMBLY: "MissionTrusteeContractGeneralAssembly",
	CUSTOMER_LOGIN_AGENCY_SCOPING: "CustomerLoginAgencyScoping",
	CUSTOMER_PORTAL_DDPP_LEGAL_BANNER: "CustomerPortalDdppLegalBanner",
	MYFONCIA_LANDLORD_KPI: "MyFonciaLandlordKPI",
	MYFONCIA_LANDLORD_PROPERTY_TAX: "MyFonciaLandlordPropertyTax",
	CUSTOMER_PORTAL_LANDLORD_FUNDS_CALLS_PAYMENT: "CustomerPortalLandlordFundsCallsPayment",
	CUSTOMER_PORTAL_ACCOUNTING_WORK_TAB: "CustomerPortalAccountingWorkTab",
	NATIXIS_PAYMENT: "NatixisPayment",
	CUSTOMER_PORTAL_USE_SERVICE_NOTIFICATION_PUSH_INFO: "CustomerPortalUseServiceNotificationPushInfo",
	USE_SERVICE_USER_AUTH_FOR_CUSTOMER_PORTAL_STATUS: "UseServiceUserAuthForCustomerPortalStatus",
	QUOTE_ON_MISSION_INCIDENT_GL: "QuoteOnMissionIncidentGL",
	SECONDARY_REFERENCE_FIELD: "SecondaryReferenceField",
	SHOW_TREASURY_LISTING: "ShowTreasuryListing",
	BIEN_ICI_PORTAL: "BienIciPortal",
	BUILDING_PROVISION_COUNTERS_EDIT: "BuildingProvisionCountersEdit",
	SUPPLIERS__ARCHIVE_DUPLICATES_ON_CREATION: "Archive_duplicated_suppliers_on_creation",
	ALLOCATION_PROPOSITION_EDIT: "AllocationPropositionEdit",
	MISSION_GENERAL_ASSEMBLY_POSTAL_VOTE_VOTES_RECOVERY: "MissionGeneralAssemblyPostalVoteVotesRecovery",
	MISSION_NEW_MANDATE_BUILDING_SERVICES: "MissionNewMandateBuildingServices",
	COMPOSITE_INDEX: "CompositeIndexe",
	EXTERNAL_EXPENSES_REGULARIZATION_FOR_INSTITUTIONAL_LESSOR: "ExternalExpensesRegularizationForInstitutionalLessor",
	EXPENSE_REGULARIZATION_AUTOMATION_CHARGE_PROVISIONS: "ExpenseRegularizationAutomationChargeProvisions",
	BUILDING_TRANSFER: "BuildingTransfer",
	CROSS_AGENCIES_BUILDING_TRANSFER: "CrossAgenciesBuildingTransfer",
	HOLD_KYRIBA_PAYMENTS_DURING_BUILDING_TRANSFER: "HoldKyribaPaymentsDuringBuildingTransfer",
	DISPLAY_MISSION_ON_BUDGET_REPAIR_TO_DO: "DisplayMissionOnBudgetRepair",
	BUDGET_REPAIR_TO_DO_WITH_SEVERAL_ALLOCATION_KEYS: "BudgetRepairToDoWithSeveralAllocationKeys",
	GA_CALL__DELIVERY_AGAINST_SIGNATURE: "GACallDeliveryAgainstSignature",
	GA_PRE_ASSEMBLY_CHECKS: "GAPreAssemblyChecks",
	DISPLAY_ASYNC_COMPUTE_FINANCIAL_SITUATION_BUTTON: "DisplayAsyncComputeFinancialSituationButton",
	KYRIBA_IN_AGENCY_BY_BANK_INFORMATION: "KyribaInAgencyByBankInformation",
	KYRIBA_SEPA_PAIN_VERSION_2019: "KyribaSepaPainVersion2019",
	BANK_TRANSACTION_COMPLEMENTARY_DETAILS: "BankTransactionComplementaryDetails",
	ALLOW_CHANGE_REPARTITION_STATUS: "AllowChangeRepartitionStatus",
	NON_AUTOMATIC_DPV: "NonAutomaticDpv",
	CUSTOMER_PORTAL_UPDATE_LANDLOARD_IBAN_DATA: "CustomerPortalUpdateLandlordIbanData",
	CUSTOMER_PORTAL_UPDATE_TENANT_HEATER_CERTIFICATE: "CustomerPortalUpdateTenantHeaterCertificate",
	CUSTOMER_PORTAL_DYNAMIC_DPV: "CustomerPortalDynamicDPV",
	CUSTOMER_PORTAL_DPV_WITHDRAWAL: "CustomerPortalDpvWithdrawal",
	CUSTOMER_PORTAL_ELECTRONIC_INVOICING_DPV: "CustomerPortalElectronicInvoicingDPV",
	CUSTOMER_PORTAL_ELECTRONIC_INVOICING_FIELDS_CONFIGURATION: "CustomerPortalElectronicInvoicingFieldsConfiguration",
	CUSTOMER_PORTAL_PLATO__DOCUMENTS_MIGRATION__SEPA_MANDATE: "CustomerPortalPlatoDocumentsMigrationSepaMandate",
	CUSTOMER_PORTAL_DISPLAY_MISSION_INCIDENTS: "CustomerPortalDisplayMissionIncidents",
	CUSTOMER_PORTAL_DOCUMENTS_NOTIFICATIONS: "CustomerPortalDocumentsNotifications",
	CUSTOMER_PORTAL_EXCLUDE_SOLD_UNITS: "CustomerPortalExcludeSoldUnits",
	CUSTOMER_PORTAL_CONSENT_PLATFORM: "CustomerPortalConsentPlatform",
	CUSTOMER_PORTAL_BIOMETRIC_LOCK: "CustomerPortalBiometricLock",
	CUSTOMER_PORTAL_BETTER_PDF_READER: "CustomerPortalBetterPdfReader",
	MIGRATE_CUSTOMER_PUSH_NOTIFICATION_TO_MS_CUSTOMER: "MigrateCustomerPushNotificationToMsCustomer",
	TRUSTEE_CONTRACT_NEW_MANDATE_CREATION: "TrusteeContractNewMandateCreation",
	TRUSTEE_CONTRACT_NEW_MANDATE_DISPLAY: "TrusteeContractNewMandateDisplay",
	TENOR_INVOICES_REJECT_TYPES: "TenorInvoicesRejectTypes",
	EXTERNAL_GROWTH_NEW_MANDATE_DISPLAY: "ExternalGrowthNewMandateDisplay",
	ALLOW_TO_DELETE_BUILDING_DOCUMENT: "AllowAccountingDirectorToDeleteBuildingFile",
	ALLOW_TO_DELETE_EMPLOYEE_PAYSLIP_FILE: "AllowSupportToDeleteEmployeePayslipFile",
	LEGACY_MANDATE_DISPLAY: "LegacyMandateDisplay",
	DISTRIBUTE_BUDGETS_WORKFLOW: "distributeBudgetsWorkflow",
	PRIVATE_CHARGES: "PrivateCharges",
	INVOICES_WITHOUT_AGENCY: "InvoicesWithoutAgency",
	RIB_MODIFICATION_CENTRAL_TEAM: "ribModificationCentralTeam",
	ML_LOC_RENTAL_APPLICATION_FORM_API_P2: "ML_LOC_RENTAL_APPLICATION_FORM_API_P2",
	SECURE_INPUT_MIDDLEWARE: "SecureInputMiddleware",
	USER_SCOPE_AUTHORIZATION: "UserScopeAuthorization",
	USER_AUTH_PRIMARY_SOURCE: "UserAuthPrimarySource",
	TRUSTEE_DESIGNATION_RESOLUTION_SUFFIX: "TrusteeDesignationResolutionSuffix",
	USER_AUTH_WRITE: "UserAuthWrite",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_OPERATING_LEASE_REPORT: "StopReferencingPlatoCustomerCredentialsInOperatingLeaseReport",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_ACCOUNT_OFFSET_INVOICE: "StopReferencingPlatoCustomerCredentialsInAccountOffsetInvoice",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_ACCOUNT_STATUS: "StopReferencingPlatoCustomerCredentialsInAccountStatus",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_RENTAL_DUE_NOTICE: "StopReferencingPlatoCustomerCredentialsInRentalDueNotice",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_RENTAL_RENT_RECEIPT: "StopReferencingPlatoCustomerCredentialsInRentalRentReceipt",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_PDF_WORDING_PAYMENT: "StopReferencingPlatoCustomerCredentialsInPdfWordingPayment",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_SALE_TRANSFER_NOTICE: "StopReferencingPlatoCustomerCredentialsInSaleTransferNotice",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_MISSION_GENERAL_ASSEMBLY: "StopReferencingPlatoCustomerCredentialsInMissionGeneralAssembly",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_MISSION_SALE_AGREEMENT: "StopReferencingPlatoCustomerCredentialsInMissionSaleAgreement",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_SALE_AGREEMENT_INVOICE: "StopReferencingPlatoCustomerCredentialsInSaleAgreementInvoice",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_SALE_AGREEMENT: "StopReferencingPlatoCustomerCredentialsInSaleAgreement",
	USER_AUTH_UPDATE_LOGIN_DISABLED: "UserAuthUpdateLoginDisabled",
	USER_AUTH_AUTO_ENABLE_OKTA_FF_NEW_LOGIN: "UserAuthAutoEnableOktaFFNewLogin",
	USER_AUTH_LOGIN_ACTION_INFO_BANNER: "UserAuthLoginActionInfoBanner",
	USER_AUTH_SEND_ACCOUNT_ACCESS_EMAIL: "UserAuthSendAccountAccessEmail",
	USER_AUTH_SEND_EMAIL_ON_LOGIN_UNLINKED: "UserAuthSendEmailOnLoginUnlinked",
	USER_AUTH_SEND_EMAIL_ON_LOGIN_DELETED: "UserAuthSendEmailOnLoginDeleted",
	OKTA_FIRST_CONNECTION_IDENTIFIER_MANAGEMENT: "OktaFirstConnectionIdentifierManagement",
	OKTA_FIRST_CONNECTION_NO_EMAIL_CHECKBOX: "OktaFirstConnectionNoEmailCheckbox",
	NEW_DPE_TAGS: "NewDPETags",
	ML_ADMIN_N2_GRANT: "MLAdminN2Grant",
	ML_ADMIN_RA_MANAGEMENT: "MlAdminRaManagement",
	NEW_GLI_RATE: "NewGLIRate",
	TRANSFER_WITH_ERROR_PROCESS_STATUS: "TransferWithErrorProcessStatus",
	CO_OWNERSHIP_MODIFICATION: "CoOwnershipModification",
	CO_OWNERSHIP_MODIFICATION_V2: "CoOwnershipModificationV2",
	LISTING_CUSTOMERS_SEARCH_BY_QUALITIES: "ListingCustomersSearchByQualities",
	ALL_OTHER_CASH_ADVANCES_CUSTOM_TIMETABLE_EDITOR: "AllOtherCashAdvancesCustomTimetableEditor",
	BLOCK_LOSS_DATES_EDITION: "BlockLossDatesEdition",
	PLATO__DOCUMENTS_MIGRATION__COOWNERSHIP_APPENDIXES: "PlatoDocumentsMigrationCoownershipAppendixes",
	MyFonciaTenantList: "MyFonciaTenantList",
	ACCESS_MISSION_REPAIR_WITH_SCOPES: "AccessMissionRepairWithScopes",
	AUTOMATIC_INVOICING_DATED_STATE: "AutomaticInvoicingDatedState",
	REFUND_COLLECTIVE_LOAN: "RefundCollectiveLoan",
	MISSION_COLLECTIVE_LOAN: "MissionCollectiveLoan",
	PORTFOLIO_TRANSFER: "PortfolioTransfer",
	SCOPE_INTERFACE: "ScopeInterface",
	MyFonciaRentalSituation: "MyFonciaRentalSituation",
	WORK_FUND_RESERVE_AUTOMATED_BANK_OPERATION: "WorkFundReserveAutomatedBankOperation",
	LISTING_BUILDING_PRINCIPAL_UNITS: "ListingBuildingPrincipalUnits",
	LISTING_BUILDING_V2: "ListingBuildingV2",
	LISTING_MULTIPLE_AGENCIES: "ListingMultipleAgencies",
	LISTING_CUSTOMER_V2: "ListingCustomerV2",
	LISTING_RECOVERY_V2: "ListingRecoveryV2",
	WORK_ORDER_MULTI_INVOICES: "WorkOrderMultiInvoices",
	RENTAL_MANAGEMENT_PRIVATE_CHARGES: "RentalManagementPrivateCharges",
	RESOLUTION_REPAIR_MULTI_ANNUAL_PLAN: "ResolutionRepairMultiAnnualPlan",
	SUB_ASSOCIATES_BY_AGENCIES: "SubAssociatesByAgencies",
	FLATTEN_PDF: "FlattenPdf",
	DOCUSIGN_ELECTRONIC_SIGNATURE: "DocusignElectronicSignature",
	OKTA_AUTHENTICATION_FLOW: "OktaAuthenticationFlow",
	ALLOW_UPDATE_ACCOUNT_ON_SCREEN_BANK_RECONCILIATION: "AllowUpdateAccountOnScreenBankReconciliation",
	LANGUAGE_SWITCHER: "LanguageSwitcher",
	LESSOR_FURNISHED_LEASE_TAX_DECLARATION: "LessorFurnishedLeaseTaxDeclaration",
	DISTRIBUTE_BUDGETS_AFTER_GA: "DistributeBudgetsAfterGA",
	RESCUE_EXERCISE_ON_DISTRIBUTION_FAILURE: "RescueExerciseOnDistributionFailure",
	MANUAL_BANK_OPERATION_FORM_V2: "ManualBankOperationFormV2",
	MILLENIUM_EXPERT_CHATBOT: "MilleniumExpertChatbot",
	MILLENIUM_EXPERT_CHATBOT_AGENT_V2: "MilleniumExpertChatbotAgentV2",
	MILLENIUM_EXPERT_CHATBOT_FRONT_ACCOUNTING: "MilleniumExpertChatbotFrontAccounting",
	MILLENIUM_EXPERT_CHATBOT_FRONT_ADB: "MilleniumExpertChatbotFrontAdb",
	RENTAL_MANAGEMENT_SETTINGS_VIA_MANDATE_WRITE: "RentalManagementSettingsViaMandateWrite",
	RENTAL_MANAGEMENT_SETTINGS_VIA_UNIT_DISABLED: "RentalManagementSettingsViaUnitDisabled",
	PLATO_DOCUMENTS_MIGRATION__COOWNERSHIP_WORK_FEES_PROPOSAL: "PlatoDocumentsMigrationCoownershipWorkFeesProposal",
	PLATO__DOCUMENTS_MIGRATION__CUSTOMER_ACCOUNTING_STATEMENT: "PlatoDocumentsMigrationCustomerAccountingStatement",
	PLATO__DOCUMENTS_MIGRATION__COOWNERSHIP_POSTAL_VOTING_FORM: "PlatoDocumentsMigrationCoownershipPostalVotingForm",
	PLATO__DOCUMENTS_MIGRATION__COOWNERSHIP_SALE_AGREEMENT: "PlatoDocumentsMigrationCoownershipSaleAgreement",
	PLATO__DOCUMENTS_MIGRATION__COOWNERSHIP_SALE_AGREEMENT_INVOICE: "PlatoDocumentsMigrationCoownershipSaleAgreementInvoice",
	PLATO__DOCUMENTS_MIGRATION__WELCOME_MAIL_OLD_BUILDING: "PlatoDocumentsMigrationWelcomeMailOldBuilding",
	PLATO__DOCUMENTS_MIGRATION__MULTIRISK_INSURANCE: "PlatoDocumentsMigrationMultiriskInsurance",
	COMMERCIAL_LEASE_BACK_PAY: "CommercialLeaseBackPay",
	NEW_RENT_REVIEW_LAYOUT: "NewRentReviewLayout",
	MINUTES_TEMPORAL: "MinutesTemporal",
	DEFICIENCY_MINUTES_TEMPORAL: "DeficiencyMinutesTemporal",
	DOC_GEN_V2_ACCOUNT_STATUS: "DocGenV2AccountStatus",
	DOC_GEN_V2_AG_CONVOCATION: "DocGenV2AgConvocation",
	DOC_GEN_V2_BUILDING_MAINTENANCE_LOG: "DocGenV2BuildingMaintenanceLog",
	DOC_GEN_V2_COOWNERSHIP_ACCOUNTING: "DocGenV2CoownershipAccounting",
	DOC_GEN_V2_COOWNERSHIP_APPENDIXES: "DocGenV2CoownershipAppendixes",
	DOC_GEN_V2_EXPENSES_REPARTITION: "DocGenV2ExpensesRepartition",
	DOC_GEN_V2_GENERAL_ASSEMBLY: "DocGenV2GeneralAssembly",
	DOC_GEN_V2_INVOICE_FEES: "DocGenV2InvoiceFees",
	DOC_GEN_V2_LEASE_DOCUMENTS: "DocGenV2LeaseDocuments",
	DOC_GEN_V2_MANDATE_AND_SALES: "DocGenV2MandateAndSales",
	DOC_GEN_V2_RECOVERY_REMINDERS: "DocGenV2RecoveryReminders",
	DOC_GEN_V2_RENTAL_ACCOUNTING: "DocGenV2RentalAccounting",
	DOC_GEN_V2_RENTAL_DUE_NOTICE: "DocGenV2RentalDueNotice",
	DOC_GEN_V2_TRANSFER_NOTIFICATION: "DocGenV2TransferNotification",
	LEDGER_PAYLOAD_PARTS: "LedgerPayloadParts",
	DOC_MERGE_COMPRESSION: "DocMergeCompression",
	DOC_MERGE_IN_PROCESS: "DocMergeInProcess",
	EQUIPMENTS: "Equipments",
	EQUIPMENTS_CSV_ANNOUNCES: "EquipmentsCsvAnnounces",
	LISTING_BUILDING_REMOVE_INITIAL_AGENCY_FILTER: "ListingBuildingRemoveInitialAgencyFilter",
	INVOICE_MIGRATE_STATUS_FROM_PAID_TO_CASHED: "invoiceMigrateStatusFromPaidToCashed",
	INVOICE_MIGRATE_STATUS_FROM_PAID_TO_CASHED_RECONCILIATION_BANK: "invoiceMigrateStatusFromPaidToCashedReconciliationBank",
	TAG_KEY_ACCOUNT: "TagKeyAccount",
	SPLIT_ACCOUNTING_INVOICES: "SplitAccountingInvoices",
	SPLIT_ACCOUNTING_INVOICES_V2: "SplitAccountingInvoicesV2",
	SKIP_ACCOUNTING_LINES_LETTERING_FOR_MAJOR_ACCOUNTS_ON_INVOICE_PAYMENT: "SkipAccountingLinesLetteringForMajorAccountsOnInvoicePayment",
	ACCOUNTING_LINE_PER_RENT_VARIABLE_ENTRY: "AccountingLinePerRentVariableEntry",
	ACCOUNTING_LINE_PER_RENT_VARIABLE_ENTRY_WITH_ACCOUNTING_CLASS: "AccountingLinePerRentVariableEntryWithAccountingClass",
	SPLIT_ACCOUNTING_LINE_INTO_NET_AND_VAT: "SplitAccountingLineIntoNetAndVat",
	SPLIT_ACCOUNTING_LINE_INTO_HT_AND_VAT_ON_VARIABLES: "SplitAccountingLineIntoHtAndVatOnVariables",
	HIDE_LEASE_VAT_VARIABLES: "HideLeaseVatVariables",
	RENTAL_MANAGEMENT_UNIT_LOSS: "RentalManagementUnitLoss",
	TENANT_LEAVE_ASSURIMO: "TenantLeaveAssurimo",
	DOCUSIGN_PV: "DocusignPV",
	DISABLE_UPLOAD_SIGNED_MINUTES: "DisableUploadSignedMinutes",
	MINUTES_REGISTERED_MAIL_TO_ALL_CO_OWNERS: "MinutesRegisteredMailToAllCoOwners",
	DISPLAY_CUSTOM_FORM_DIVERSE_OPERATION_RENTAL_MANAGEMENT_ACCOUNT_REDDITION: "DisplayCustomFormDiverseOperationRentalManagementAccountReddition",
	RECOVERY_FILES_EXTRACTION_CURSOR: "RecoveryFilesExtractionCursor",
	SEND_NEW_TENANT_WELCOME_EMAIL_WITH_IMPORTED_PROSPECT_APP_LOGIN: "SendNewTenantWelcomeEmailWithImportedProspectAppLogin",
	BANK_OPERATION_WITH_THIRD_PARTY_ACCOUNTING_ACCOUNT_ML17276: "BankOperationWithThirdPartyAccountingAccount_ML17276",
	MINUTES_DISCHARGE_RABBIT: "MinutesDischargeRabbit",
	OD_BETWEEN_7000_LESSOR_AND_7000_BUILDING: "ODBetween7000LessorAnd7000Building",
	RGI_IRRECOVERABLE_DEBT: "RgiIrrecoverableDebt",
	EXPENSE_REGULARIZATION_AUTOMATION: "ExpenseRegularizationAutomation",
	EXPENSE_REGULARIZATION_AUTOMATION_REASSSESSMENT_PROVISIONS: "ExpenseRegularizationAutomationReasssementProvisions",
	HIDE_HOME_PAGE_BUILDING_WIDGET: "HideHomePageBuildingWidget",
	CONFIRMATION_RECAP_MINUTES_VALIDATION: "ConfirmationRecapMinutesValidation",
	END_OF_RENTAL_MANAGEMENT_OLR: "EndOfRentalManagementOlr",
	DISPLAY_TENANT_LEAVE_REGULARIZATION_PERIOD: "DisplayTenantLeaveRegularizationPeriod",
	END_OF_RENTAL_MANAGEMENT_MISSION: "EndOfRentalManagementMission",
	END_OF_RENTAL_MANAGEMENT_MISSION_BO_OLR_ACCESS: "EndOfRentalManagementMissionBoOlrAccess",
	MISSION_PROPERTY_REPAIR: "MissionPropertyRepair",
	PROPERTY_MANAGEMENT_BUDGET: "PropertyManagementBudget",
	TAX_CONFIGURATION_INTERFACE: "TaxConfigurationInterface",
	IGNORE_OPERATING_LEASE_REPORT_SCHEDULE_DATE: "IgnoreOperatingLeaseReportScheduleDate",
	CATCH_UP_OPERATING_LEASE_REPORT_SCHEDULE: "CatchUpOperatingLeaseReportSchedule",
	CATCH_UP_OPERATING_LEASE_REPORT_DATES: "CatchUpOperatingLeaseReportDates",
	OPERATING_LEASE_REPORT_INCLUDE_INVOICES_CONFIG: "OperatingLeaseReportIncludeInvoicesConfig",
	SCOPE_DEBUGGER: "ScopeDebugger",
	CANCEL_UPCOMING_TRANFER: "CancelUpcomingTranfer",
	USE_MS_PUBLICATION_V2: "UseMsPublicationV2",
	PUBLICATION_TRIGGERS_TEMPORAL: "PublicationTriggersTemporal",
	SYNC_TRANSACTIONS_PUBLICATION_ADS_TEMPORAL: "SyncTransactionsPublicationAdsTemporal",
	FEES_TVA_DISPLAY: "FeesTVADisplay",
	CRG_FEES_PARAGRAPH_SEPARATION: "CrgFeesParagraphSeparation",
	CRG_WORKS_FUNDS_CALLS_SITUATION: "CrgWorksFundsCallsSituation",
	DISPLAY_PROPERTY_MANAGEMENT_TOGGLE: "displayPropertyManagementToggle",
	CUSTOMER_PORTAL_OUTGOING_TICKET: "CustomerPortalOutgoingTicket",
	END_OF_RENTAL_MANAGEMENT_MISSION_PARTIAL: "EndOfRentalManagementMissionPartial",
	PARTIAL_INVOICE_PAYMENT_PER_CODIFICATION: "PartialInvoicePaymentPerCodification",
	EXTERNAL_EXPENSE_REGULARIZATION_FROM_INVOICE: "ExternalExpenseRegularizationFromInvoice",
	BRAND_MODEL_CENTRALIZATION: "brandModelCentralization",
	ACCOUNTING_SERVICE_REQUEST: "AccountingServiceRequest",
	ELECTRONIC_INVOICING_FIELDS_CONFIGURATION: "ElectronicInvoicingFieldsConfiguration",
	ELECTRONIC_INVOICING_IDENTIFIER_FIELDS_CONFIGURATION: "ElectronicInvoicingIdentifierFieldsConfiguration",
	ELECTRONIC_INVOICING_RENT_DETAILS_CALL: "ElectronicInvoicingRentDetailsCall",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_NEW_TENANT_WELCOME_EMAIL: "StopReferencingPlatoCustomerCredentialsInNewTenantWelcomeEmail",
	ACCOUNT_OFFSET_ADF_TEMPORAL: "AccountOffsetAdfTemporal",
	CREATE_REPARTITION_ACCOUNT_OFFSET_TEMPORAL: "CreateRepartitionAccountOffsetTemporal",
	CANCEL_FUTURE_CO_OWNERSHIP_MANDATE: "CancelFutureCoOwnershipMandate",
	REACTIVATE_CO_OWNERSHIP_MANDATE: "ReactivateCoOwnershipMandate",
	BLOCK_GLI_DEPOSITS_LOSING_MANAGEMENT: "BlockGliDepositsLosingManagement",
	ALLOW_DELETE_APPROBATION_COMPTES: "AllowDeleteApprobationComptes",
	END_OF_RENTAL_MANAGEMENT_TERMINATION_NOTICE: "EndOfRentalManagementTerminationNotice",
	END_OF_RENTAL_MANAGEMENT_MISSION_ACTIVITY_RECORDS: "EndOfRentalManagementMissionActivityRecords",
	END_GENERAL_ASSEMBLY_ASYNC_TEMPORAL: "EndGeneralAssemblyAsyncTemporal",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_CO_OWNER_ACCOUNT_REPARTITION: "StopReferencingPlatoCustomerCredentialsInCoOwnerAccountRepartition",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_GL_CUSTOMER_DATA: "StopReferencingPlatoCustomerCredentialsInGlCustomerData",
	RFE_FEE_INVOICE_CONSOLIDATION: "RfeFeeInvoiceConsolidation",
	VALIDATE_HONB_DUES_WITH_TEMPORAL: "ValidateHonbDuesWithTemporal",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_PDF_CUSTOMER: "StopReferencingPlatoCustomerCredentialsInPdfCustomer",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_MISSION_SALE_AGREEMENT_CREATION: "StopReferencingPlatoCustomerCredentialsInMissionSaleAgreementCreation",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_CAN_CUSTOMER_ACCESS_MYFONCIA: "StopReferencingPlatoCustomerCredentialsInCanCustomerAccessMyfoncia",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_CURRENT_CUSTOMER_AUTHENTICATION: "StopReferencingPlatoCustomerCredentialsInCurrentCustomerAuthentication",
	OWNER_WELCOME_EMAIL: "OwnerWelcomeEmail",
	END_OF_RENTAL_MANAGEMENT_SCHEDULE_OLR: "EndOfRentalManagementScheduleOlr",
	END_OF_RENTAL_MANAGEMENT_REQUEST_ACCOUNTING_CLOSURE: "EndOfRentalManagementRequestAccountingClosure",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_CUSTOMER_PAYMENT: "StopReferencingPlatoCustomerCredentialsInCustomerPayment",
	SALE_TRANSFER_NOTICE_TEMPORAL: "SaleTransferNoticeTemporal",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_FUNDS_CALL_DOCUMENT: "StopReferencingPlatoCustomerCredentialsInFundsCallDocument",
	END_OF_RENTAL_MANAGEMENT_ACCOUTING_CLOSURE: "EndOfRentalManagementAccountingClosure",
	END_OF_RENTAL_MANAGEMENT_LESSOR_TAX_DECLARATION: "EndOfRentalManagementLessorTaxDeclaration",
	TICKET_REMINDER_OUTGOING: "TicketReminderOutgoing",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_WELCOME_BUILDING_CREATION_EMAIL: "StopReferencingPlatoCustomerCredentialsInWelcomeBuildingCreationEmail",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_WELCOME_BUILDING_INTEGRATION_EMAIL: "StopReferencingPlatoCustomerCredentialsInWelcomeBuildingIntegrationEmail",
	AUTO_CLOSE_TICKETS_ENABLED: "AutoCloseTicketsEnabled",
	STOP_REFERENCING_PLATO_CUSTOMER_CREDENTIALS_IN_CO_OWNER_WELCOME_PACK: "StopReferencingPlatoCustomerCredentialsInCoOwnerWelcomePack",
	CHANGE_AGENCY_ON_PRIMARY_CLUSTER: "ChangeAgencyOnPrimaryCluster",
	FILTER_ACCOUNT_CLASS_IN_DIVERSE_OPERATIONS: "FilterAccountClassInDiverseOperations",
	CUSTOM_AMOUNT_CODIFICATION: "CustomAmountCodification",
	FL_REPORTING: "FLReporting",
	MANY_REFERENCE_YEARS_SELECTION_DPE: "ManyReferenceYearsSelectionDpe",
	EQUIPEMENTS: "Equipements",
	RFE_MANUAL_RETROCEDED_INVOICE: "RfeManualRetrocededInvoice",
	RFE_GENERATE_INVOICE_ON_MANDATE_LOSS: "RfeGenerateInvoiceOnMandateLoss",
	RFE_CO_OWNER_FEE_REALLOCATION: "RfeCoOwnerFeeReallocation",
	END_OF_RENTAL_MANAGEMENT_END_LESSOR_CONTRACTS: "EndOfRentalManagementEndLessorContracts",
	ENABLE_SHOWCASE_POSTER_GENERATION_BLOCKING: "EnableShowcasePosterGenerationBlocking",
	DISPLAY_OUTGOING_INVOICES: "DisplayOutgoingInvoices",
	DISPLAY_OUTGOING_INVOICE_UBL_DOWNLOAD: "DisplayOutgoingInvoiceUblDownload",
	DUES_GL_IN_MS_FEES: "DuesGlInMsFees",
	DUES_BILLING_ML_ADMIN: "DuesBillingMlAdmin",
	RENTAL_MANAGEMENT_FEES_POTENTIAL_ACCOUNTING: "RentalManagementFeesPotentialAccounting",
	RESCHEDULE_OVERDUE_UNSENT_DEBITS: "RescheduleOverdueUnsentDebits",
	EXTERNAL_EXPENSE_REGULARIZATION_PAGE_V2: "ExternalExpenseRegularizationPageV2",
	CUSTOMER_PORTAL_UPLOAD_EXTERNAL_EXPENSE_REGULARIZATION: "CustomerPortalUploadExternalExpenseRegularization",
	EXTERNAL_EXPENSE_REGULARIZATION_AI_ANALYZE: "ExternalExpenseRegularizationAiAnalyze",
	EXTERNAL_EXPENSE_REGULARIZATION_AI_ANALYZE_FOR_INVOICES_AND_MANUAL: "ExternalExpenseRegularizationAiAnalyzeForInvoicesAndManual",
	CustomerPortalDesignV2: "CustomerPortalDesignV2",
	CENTRALIZE_GL_FEES_BY_CRG_FREQUENCY: "CentralizeGlFeesByCrgFrequency",
	SEND_CREATE_CUSTOMER_LOGIN_FROM_SIGNATURE: "SendCreateCustomerLoginFromSignature",
	OKTA_1CO_SEND_CREATE_CUSTOMER_LOGIN_LEASE: "Okta1CoSendCreateCustomerLoginLease",
	OKTA_1CO_SEND_CREATE_CUSTOMER_LOGIN_NEW_MANDATE: "Okta1CoSendCreateCustomerLoginNewMandate",
	OKTA_1CO_SEND_CREATE_CUSTOMER_LOGIN_LEASE_BACK: "Okta1CoSendCreateCustomerLoginLeaseBack",
	OKTA_1CO_SEND_CREATE_CUSTOMER_LOGIN_UNIT_TRANSFER: "Okta1CoSendCreateCustomerLoginUnitTransfer",
	OKTA_1CO_SEND_CREATE_CUSTOMER_LOGIN_SALE_TRANSFER: "Okta1CoSendCreateCustomerLoginSaleTransfer",
	OKTA_1CO_SEND_CREATE_CUSTOMER_LOGIN_OLD_BUILDING_CREATION: "Okta1CoSendCreateCustomerLoginOldBuildingCreation",
	OKTA_1CO_SEND_CREATE_CUSTOMER_LOGIN_CONSTITUTIVE_GENERAL_ASSEMBLY: "Okta1CoSendCreateCustomerLoginConstitutiveGeneralAssembly",
	OKTA_1CO_SEND_CREATE_CUSTOMER_LOGIN_EXTERNAL_GROWTH_RENTAL_MANAGEMENT: "Okta1CoSendCreateCustomerLoginExternalGrowthRentalManagement",
	OKTA_1CO_SEND_CREATE_CUSTOMER_LOGIN_EXTERNAL_GROWTH_ACTIVATION: "Okta1CoSendCreateCustomerLoginExternalGrowthActivation",
	SALE_TRANSFER_ACCOUNTING_RESOLUTION: "SaleTransferAccountingResolution",
	UNITS_TRANSFER_INTERNATIONAL_PHONE_FIELD: "UnitsTransferInternationalPhoneField",
	LITIGATION_MANAGER_PROFILE: "LitigationManagerProfile",
	ELECTRONIC_INVOICING_247: "ElectronicInvoicing247",
	EXPENSE_STATEMENT_TEMPORAL: "ExpenseStatementTemporal",
	LESSOR_PROPERTY_TAX_STATEMENT_TEMPORAL: "LessorPropertyTaxStatementTemporal",
	WORKDAY_FEES_INVOICE_EXPORT: "WorkdayFeesInvoiceExport",
	LITIGATION_PROCEDURE_CREATION: "LitigationProcedureCreation",
	LITIGATION_PROCEDURE_ELIGIBILITY_TAGS: "LitigationProcedureEligibilityTags",
	BLOCK_MISCELLANEOUS_CONTRACT_TYPE: "BlockMiscellaneousContractType",
	ALLOCATION_KEY_UNITS_ON_DEMAND: "AllocationKeyUnitsOnDemand",
	ELECTRONIC_INVOICING_DISPLAY_CODIFICATIONS: "ElectronicInvoicingDisplayCodifications",
	ENABLE_GLI_CONSOLIDATION: "EnableGliConsolidation",
	LESSOR_EXCEPTIONAL_FUNDS_CALL: "LessorExceptionalFundsCall",
	CONFIRMATION_MANDATE_LOSS_ABANDON: "ConfirmationMandateLossAbandon"
};
//#endregion
export { FeatureFlags };

//# sourceMappingURL=index.mjs.map